import { FC, useCallback } from 'react'
import { useHistory } from 'react-router-dom'
import {
  AppState,
  Auth0Provider as Auth0ProviderComponent,
} from '@auth0/auth0-react'

const Auth0Provider: FC = ({ children }) => {
  const history = useHistory()

  const audience = process.env.REACT_APP_AUTH0_AUDIENCE || ''
  const clientId = process.env.REACT_APP_AUTH0_CLIENT_ID || ''
  const domain = process.env.REACT_APP_AUTH0_DOMAIN || ''

  const onRedirectCallback = useCallback(
    (appState: AppState): void => {
      history.push(appState?.returnTo || `${window.location.pathname}`)
    },
    [history]
  )

  return (
    <Auth0ProviderComponent
      audience={audience}
      clientId={clientId}
      domain={domain}
      redirectUri={
        window.location.href.includes('error=access_denied')
          ? `${window.location.origin}/logout-sso`
          : window.location.origin
      }
      onRedirectCallback={onRedirectCallback}
      cacheLocation="memory"
    >
      {children}
    </Auth0ProviderComponent>
  )
}

export default Auth0Provider
